export default "__VITE_ASSET__RvonN7o___"